<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'pinia';
import { useAppStore } from '@/stores/app';

export default defineComponent({
  name: 'desktop-menu',
  data() {
    return {
      isDarkMode: true,
    };
  },
  methods: {
    ...mapActions(useAppStore, ['setToken']),
    logout() {
      this.setToken(null);
      this.$router.push('/');
    },
  },
  props: ['items'],
  watch: {
    isDarkMode(n) {
      if (n) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
  },
});
</script>

<template>
  <ul class="p-2">
    <div />
    <li v-for="item in items" class="py-2">
      <router-link v-if="item.route" :to="item.route" class="cursor-pointer">
        <i :class="{ [item.icon]: true, 'text-xl pt-2': true }" />
        <label class="pt-2 pb-5">{{ item.label }}</label>
      </router-link>
    </li>
    <li>&nbsp;</li>

    <li @click="isDarkMode = !isDarkMode">
      <span>
        <i :class="{
          'pi text-xl pt-2 pl-1 pb-5': true,
          'text-yellow-500 pi-sun': !isDarkMode,
          'text-cyan-500 pi-sparkles': isDarkMode,
        }" />
        <label class="pt-2 pb-5">Темная/светлая тема</label>
      </span>
    </li>

    <li @click="logout">
      <span>
        <i class="pi pi-sign-out text-lg pt-2 pl-1 text-red-500" />
        <label class="pt-2 pb-5">Выход</label>
      </span>
    </li>
  </ul>
</template>

<style scoped lang="scss">
ul {
  @apply p-2 relative;

  &:hover > div {
    @apply rounded-r-xl absolute top-0 bottom-0 left-10 w-60 bg-[#fff8] dark:bg-[#1118];
    backdrop-filter: blur(3px);
  }

  li {
    @apply text-center;
    a {
      @apply relative;
    }
    a:hover {
      @apply text-yellow-400;
    }

    span {
      @apply relative;

      label {
        @apply absolute text-left text-lg text-nowrap px-2;
        display: none;
      }
    }

    span:hover label {
        @apply text-yellow-400;
    }

    a label {
        @apply hidden absolute text-left text-lg text-nowrap px-2;
        //display: none;
    }

    &:first-of-type a label {
      @apply rounded-tr-xl;
    }

    &:last-of-type a label {
      @apply rounded-br-xl;
    }
  }

  &:hover a label,
  &:hover span label {
    @apply inline-block ml-2 w-60;
  }
}
</style>